import { useResponsive, useWebToggles } from '@dustin-web/microsite-components/src/hooks'
import Card from './product-card'
import type { Props } from '../product-card-gallery'
import dynamic from 'next/dynamic'

const ProductAccessoriesCard = dynamic(
  () => import('../productAccessories/product-accessories-card')
)

export default function Container(props: Props) {
  const { breakpoints } = useResponsive()
  const { isToggleEnabled } = useWebToggles()
  const availabilityTestToggle = isToggleEnabled('availability-styling-updates')

  if (breakpoints.max.SM && availabilityTestToggle) {
    return <ProductAccessoriesCard {...props} breakpoints={breakpoints} />
  } else {
    return (
      <Card
        {...props}
        breakpoints={breakpoints}
        toggles={{ availabilityTest: availabilityTestToggle }}
      />
    )
  }
}
